var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPower20 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3,9H9.7C9.3,9,9,8.7,9,8.3V0.7C9,0.3,9.3,0,9.7,0h0.6C10.7,0,11,0.3,11,0.7v7.6C11,8.7,10.7,9,10.3,9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19,10c0,5.1-4.2,9.1-9.3,9C4.8,18.9,0.8,14.6,1,9.7c0.1-2.2,1-4.3,2.4-5.8c0.4-0.5,1.2-0.4,1.6,0.2l0,0 c0.2,0.4,0.2,0.9-0.1,1.2c-1.3,1.4-2,3.3-1.8,5.4c0.3,3.3,2.9,6,6.2,6.3c4.2,0.4,7.8-2.8,7.8-7c0-1.8-0.7-3.5-1.8-4.7 c-0.3-0.3-0.3-0.8-0.1-1.2l0,0c0.4-0.5,1.1-0.6,1.6-0.1C18.1,5.5,19,7.7,19,10z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPower20, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/power-20.198ee785.svg";
export { ForwardRef as ReactComponent };